import { useQuery } from '@tanstack/react-query'

import { apiClient } from '@/lib/api-client'

import type { GetNotificationStatsResponse } from './notifications.types'

const getNotificationStats =
  async (): Promise<GetNotificationStatsResponse> => {
    const response = await apiClient.get<GetNotificationStatsResponse>(
      '/v1/platform/notifications/stats',
    )
    return response.data
  }

export const useGetNotificationStats = () => {
  return useQuery({
    queryKey: ['notification-stats'],
    queryFn: () => getNotificationStats(),
    refetchInterval: 60_000,
  })
}
